import { useState } from 'react'
import { MainBlock, CardsBlock, OfficeSchedule, MobileOfficeModal, PageHead } from '@/components'
import { clientsSmall } from '@/lib/config'

const meta = {
    title: 'Мобильный офис | "Центр финансовых консультаций"',
    description:
        'Зайди и смотри рассписание мобильного офиса "Центр финансовых консультаций". Передвижной офис выдает выгодные кредиты по всей стране',
}

const MobileOffice = ({ offices, cities }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false)

    return (
        <>
            <PageHead meta={meta}/>
            <MainBlock
                title="Мобильный офис"
                text="Кредиты с доставкой в Ваш город."
                img={{
                    preview_530: '/images/mobile-office.png',
                    preview_300: '/images/mobile-office-mobile.png',
                }}
                largeImg
                buttonText="Оставить заявку"
                onBtnClick={() => setModalIsOpen(true)}
                pb="small"
                noDots
            />
            <OfficeSchedule offices={offices} cities={cities} />
            <CardsBlock
                title="К нам обращаются даже, если это клиенты:"
                blocks={clientsSmall}
                counter
                pt={!offices?.length && 'standart'}
                pb="standart"
            />
            <MobileOfficeModal isOpen={modalIsOpen} onClose={setModalIsOpen} />
        </>
    )
}

MobileOffice.getInitialProps = async ({ api, query }) => {
    const { city, dateTo, dateFrom } = query
    const offices = await api.mobileOffices({
        filter: { city_id: city, date: [dateFrom, dateTo ?? dateFrom] },
    })
    const cities = await api.mobileOfficesCities()

    return { offices: offices.data, cities: cities.data }
}

export default MobileOffice
